import React from 'react'

type DynamicCardsProps = {
  card: string
  [key: string]: any // Additional props
}

const DynamicCards = ({ card, ...props }: DynamicCardsProps) => {
  const cardName = `${card.charAt(0).toUpperCase()}${card.slice(1)}`
  const ComponentToRender = require(`./${cardName}`).default
  return <ComponentToRender {...props} />
}

export default DynamicCards
